import { RouterDataLinks } from '@campaign-portal/components-library';
import { ClientsComponent } from '../../pages/clients/clients.component';
import { RulesComponent } from '../../pages/rules/rules.component';
import { SourcesComponent } from '../../pages/sources/sources.component';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { UsersComponent } from '../../pages/users/users.component';
import { RolesComponent } from '../../pages/roles/roles.component';
import { AuthGuard } from '../../auth/auth.guard';
import { SettingsComponent } from '../../pages/settings/settings/settings.component';
// import { CurrenciesComponent } from '../../pages/settings/currencies/currencies.component';
// import { RatesComponent } from '../../pages/settings/rates/rates.component';

export const SignInLink = 'sign-in';


export const routerLinks: Readonly<RouterDataLinks> = {
	sources: {
		canActivate: [AuthGuard],
		path: 'sources',
		component: SourcesComponent,
		data: {
			permissions: ['sources.read'],
			title: 'sources.title',
			icon: 'show_chart',
			animationState: 'SourcesComponent'
		}
	},
	clients: {
		canActivate: [AuthGuard],
		path: 'clients',
		component: ClientsComponent,
		data: {
			permissions: ['clients.read'],
			title: 'clients.title',
			icon: 'group',
			animationState: 'ClientsComponent',
		}
	},
	rules: {
		canActivate: [AuthGuard],
		path: 'rules',
		component: RulesComponent,
		data: {
			permissions: ['rules.read'],
			title: 'rules.title',
			icon: 'rule',
			animationState: 'RulesComponent'
		}
	},
	settings: {
		canActivate: [AuthGuard],
		path: 'settings',
		component: SettingsComponent,
		data: {
			permissions: ['settings.read'],
			title: 'settings.title',
			icon: 'settings',
			animationState: 'SettingsComponent'
		},
		// children: [
		// 	{
		// 		path: 'settings',
		// 		component: SettingsComponent,
		// 		data: {
		// 			permissions: ['settings.read', 'settings.edit'],
		// 			title: 'settings.title',
		// 			icon: 'icon-settings',
		// 			animationState: 'SettingsComponent'
		// 		}
		// 	},
		// 	{
		// 		path: 'currencies',
		// 		component: CurrenciesComponent,
		// 		data: {
		// 			permissions: ['currencies.read'],
		// 			title: 'currencies.title',
		// 			icon: 'icon-money-1',
		// 			animationState: 'CurrenciesComponent'
		// 		}
		// 	},
		// 	{
		// 		path: 'rates',
		// 		component: RatesComponent,
		// 		data: {
		// 			permissions: ['rates.read'],
		// 			title: 'rates.title',
		// 			icon: 'icon-rate',
		// 			animationState: 'RatesComponent'
		// 		}
		// 	}
		// ]
	},
	users: {
		canActivate: [AuthGuard],
		path: 'users',
		component: UsersComponent,
		data: {
			permissions: ['users.read'],
			title: 'users_roles.users.title',
			icon: 'manage_accounts',
			animationState: 'UsersComponent'
		}
	},
	roles: {
		canActivate: [AuthGuard],
		path: 'roles',
		component: RolesComponent,
		data: {
			permissions: ['roles.read'],
			title: 'users_roles.roles.title',
			icon: 'icon-users',
			animationState: 'RolesComponent'
		}
	},
	profile: {
		canActivate: [AuthGuard],
		path: 'profile',
		component: ProfileComponent,
		data: {
			permissions: ['profile.edit'],
			title: 'users_roles.users.profile',
			icon: 'account_circle',
			animationState: 'ProfileComponent',
			hiddenMenu: true
		}
	}
};
